import { AddressCompletionRouteService } from 'common/data';
import { BaseService } from 'core/services';

class AddressCompletionService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new AddressCompletionRouteService());
	}

	find(address) {
		var url = this.routeService.find(address);
		return this.apiClient.post(url, address);
	}

	verify(address) {
		var url = this.routeService.verify(address);
		return this.apiClient.post(url, address);
	}
}

export default AddressCompletionService;
